var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_380_7691)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_380_7691)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9414 0C25.778 0 32.9414 7.16344 32.9414 16C32.9414 24.8366 25.778 32 16.9414 32C8.10485 32 0.941406 24.8366 0.941406 16C0.941406 7.16344 8.10485 0 16.9414 0Z",
    fill: "#5C94F7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.2693 22.7385L26.0027 12.4575C26.3672 12.1083 26.3672 11.5423 26.0027 11.1931L24.6828 9.92883C24.3183 9.57971 23.7273 9.57971 23.3628 9.92883L14.6094 18.3134L10.5226 14.3988C10.1581 14.0497 9.56712 14.0497 9.20264 14.3988L7.88273 15.6631C7.51826 16.0123 7.51826 16.5783 7.88273 16.9275L13.9494 22.7385C14.3139 23.0876 14.9048 23.0876 15.2693 22.7385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0219 32C8.18525 32 1.01953 24.839 1.01953 16.0023C1.01953 7.16572 8.18525 0 17.0219 0C25.8585 0 33.0242 7.16572 33.0242 16.0023C33.0195 24.839 25.8585 32 17.0219 32Z",
    fill: "#FF262B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5637 11.4326C24.7982 11.1981 24.798 10.8179 24.5633 10.5837L22.904 8.92738C22.6696 8.69344 22.29 8.69361 22.0558 8.92777L17.0317 13.9519L12.0029 8.92741C11.7687 8.69342 11.3892 8.69333 11.1549 8.9272L9.49537 10.5837C9.26068 10.8179 9.2605 11.1981 9.49497 11.4326L14.523 16.4606L9.49458 21.489C9.26026 21.7233 9.26026 22.1032 9.49458 22.3376L11.1548 23.9977C11.3891 24.232 11.769 24.232 12.0033 23.9977L17.0317 18.9693L22.0554 23.9974C22.2897 24.2319 22.6698 24.2319 22.9041 23.9976L24.5641 22.3376C24.7985 22.1032 24.7985 21.7233 24.5641 21.489L19.5357 16.4606L24.5637 11.4326Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_380_7691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.941406)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_380_7691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.941406)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.75c9d0756255a46d8ea84a7b064dcb0a.svg";
export { ForwardRef as ReactComponent };